<template>
  <div class="container">
    <PublicHeader :totalName="$t('about').title" />
    <!-- logo -->
    <div class="logo"> <img class="img" :src="platformLogo" /></div>
    <!-- 名称 -->
    <div class="title">{{ platformName }}</div>
    <!-- 版本 -->
    <div class="lable">{{ $t('about').version }} 1.0.1</div>
    <div class="content">
      <!-- 关于 -->
      <div class="item" @click="goContent(3, '')">
        <div class="left">
          <span>{{ $t('about').about }} {{ platformName }}</span>
        </div>
        <van-icon name="arrow" size="13" color="var(--ntext_color)" />
      </div>
      <!-- 产品介绍 -->
      <div class="item" @click="goContent(4, '')">
        <div class="left">
          <span>{{ $t('about').ProductIntroduction }}</span>
        </div>
        <van-icon name="arrow" size="13" color="var(--ntext_color)" />
      </div>
      <!-- 服务条款 -->
      <div class="item" @click="goContent(5, '')">
        <div class="left">
          <span>{{ $t('about').Termofservice }}</span>
        </div>
        <van-icon name="arrow" size="13" color="var(--ntext_color)" />
      </div>
      <!-- 隐私协议 -->
      <div class="item" @click="goContent(0, $t('about').PrivacyAgreement)">
        <div class="left">
          <span>{{ $t('about').PrivacyAgreement }}</span>
        </div>
        <van-icon name="arrow" size="13" color="var(--ntext_color)" />
      </div>
      <!-- 风险提示 -->
      <div class="item" @click="goContent(6, '')">
        <div class="left">
          <span>{{ $t('about').Riskstatement }}</span>
        </div>
        <van-icon name="arrow" size="13" color="var(--ntext_color)" />
      </div>
      <!-- 白皮书 -->
      <!-- <div class="item" @click="goWhite">
        <div class="left">
          <span>{{ $t('about').whitePaper }}</span>
        </div>
        <van-icon name="arrow" size="13" color="var(--ntext_color)" />
      </div> -->
    </div>
  </div>
</template>

<script>
import systemApi from '@/api/system'
import { mapGetters } from 'vuex'
import PublicHeader from '@/components/publicHeader'

export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      platformName: localStorage.getItem('platformName'),
      platformLogo: localStorage.getItem('platformLogo')
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
  },
  methods: {
    // 跳转内容
    async goContent(type, title) {
      const res = await systemApi.getContentList({ type: type })
      this.$router.push({ name: 'Detail', query: { Name: title, id: res.rows[0].contentLocalizationId } })
    },
    goWhite() {
      window.open('/cryptorix white paper.pdf');
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);


  .logo {
    padding-top: 90px;
    text-align: center;

    .img {
      border-radius: 15px;
      width: 100px;
      height: 100px;
    }
  }

  .title {
    margin-top: 10px;
    text-align: center;
    font-size: 17px;
    font-weight: bold;
    color: var(--text_color);
  }

  .lable {
    margin-top: 10px;
    text-align: center;
    font-size: 13px;
    color: var(--ntext_color);
  }

  .content {
    margin-top: 30px;

    .item {
      padding: 20px 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        display: flex;
        align-items: center;

        span {
          font-size: 15px;
          color: var(--text_color);
        }
      }

      span {
        font-size: 13px;
        color: var(--ntext_color);
        margin-right: 10px;
      }
    }
  }
}
</style>
